<template>
	<div class="fuzzy-matching-box">
		<div class="header-Top-Box">
			<div class="school-seacher">
				<!-- <el-row>
					<el-col :span="4">
						<el-form-item label="策略ID:">
							<el-input v-model="Dform.title" placeholder=''></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="策略名字：">
							<el-input v-model="Dform.publishUserName" placeholder=''></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="开始时间">
							<el-date-picker v-model="Dform.startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
								value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="结束时间">
							<el-date-picker v-model="Dform.terminalTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
								value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="进出类型:">
							<el-select v-model="Dform.type" placeholder="--请选择--">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					
					<el-col :span="5">
						<el-form-item label="通行限制:">
							<el-select v-model="Dform.type" placeholder="--请选择--">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					

					<el-col :span="5">
						<el-form-item label="创建时间">
							<el-date-picker v-model="Dform.createTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
								value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
							</el-date-picker>
						</el-form-item>
					</el-col>

					<el-col :span="10" style="margin-left: 100px;">
						<el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
					</el-col>
				</el-row> -->

				<el-row>
					<el-col :span="10" style="margin-left: 60px;">
						<el-button type="primary" class="query-button green_bottom" @click="AddclickXinxi">新增策略</el-button>
						<!-- <el-button type="primary" class="query-button red_bottom" @click="piliangClick">批量删除</el-button> -->
						<el-button type="primary" class="query-button" @click="sendStrategy">下发通行策略</el-button>
					</el-col>
				</el-row>
			</div>
		</div>

		<div class="center-table-box">
			<el-table stripe :border="true" class="table-Style" ref="multipleTable"
				:header-cell-style="{background:'#EDF6FF',color:'#000',}" :data="tableData" tooltip-effect="dark"
				style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection">
				</el-table-column>
				<el-table-column prop="strategyId" label="策略ID" width="100">
				</el-table-column>
				<el-table-column prop="strategyName" label="策略名字">
				</el-table-column>
				<el-table-column prop="stateDate" label="开始时间">
					<template #default="scope">{{scope.row.stateDate}}</template>
				</el-table-column>
				<el-table-column prop="endDate" label="结束时间">
					<template #default="scope">{{scope.row.endDate}}</template>
				</el-table-column>
				<el-table-column label="进出类型" width="120">
					<template #default="scope">
						<el-tag class="scope_grenn" v-if="scope.row.enterOrExit == 0">{{'学校进'}}</el-tag>
						<el-tag class="scope_blue" v-if="scope.row.enterOrExit == 1">{{'学校出'}}</el-tag>
						<el-tag class="scope_blue" v-if="scope.row.enterOrExit == 2">{{'宿舍进'}}</el-tag>
						<el-tag class="scope_blue" v-if="scope.row.enterOrExit == 3">{{'宿舍出'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="通行限制" width="120">
					<template #default="scope">
						<el-tag class="scope_grenn" v-if="scope.row.accessNumLimit == 1">{{'限制'}}</el-tag>
						<el-tag class="scope_grenn" v-if="scope.row.accessNumLimit == 0">{{'不限制'}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="allowCnt" label="限制次数">
				</el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
				<el-table-column prop="createDate" label="创建时间"></el-table-column>

				<el-table-column label="操作" min-width="100">
					<template #default="scope">
						<!-- <div v-if="userId == scope.row.id"> -->
						<el-button type="text" class="xiugaiBtn" @click="xiugai(scope.row)"
							style="padding: 0px;">修改</el-button>
						<el-button type="text" class="shanchuBtn" @click="deleteClick(scope.row)"
							style="padding: 0px;">删除</el-button>
						<!-- </div> -->
					</template>
				</el-table-column>
			</el-table>
			<div class="block-fenye">
				<el-pagination layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" />
			</div>
		</div>
		<AddStrategy v-if="AddStrategyView" @backClick="backClick" :titleValue="titleValue"
			:objLookTeacher="objLookTeacher"></AddStrategy>
	</div>
</template>
<script>
	import {
		noticeList,
		noticeListDelete
	} from '@/assets/api/schoollog';
	
	import {
		strategyPage,
		findTeacherInfo,
		deleteFaceStrategy,
		issuedStrategy
	} from '@/assets/api/renyuan';

	import AddStrategy from './group/add-strategy.vue';

	export default {
		name: '',
		components: {
			AddStrategy
		},

		props: {

		},
		data() {
			return {
				AddStrategyView: false,
				options: [{
					value: 1,
					label: '进门'
				}, {
					value: 2,
					label: '出门'
				}],
				Dform: {
					entTime: '',
					publishUserName: '',
					startTime: '',
					title: '',
				},
				pageInfo: {
					page: "1",
					pageSize: '10'
				},
				selectList: [],
				tableData: [],
				objLookTeacher: {},
				titleValue: "",
				userId: JSON.parse(localStorage.getItem('user')).id,
				pageInfo: {
					page: 1,
					pageSize: 10,
				},
				total: 0
			}
		},
		created() {
			this.LookTeacher()
		},
		mounted() {

		},
		methods: {
			LookTeacher() {
				const params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				findTeacherInfo(params).then((res) => {
					this.objLookTeacher = res.data.data
					console.log(res.data.data, '查看当前登录人权限');
					this.noticeListSeacher()
				}).catch((err) => {
					console.log(err);
				})
			},

			// 批量删除
			piliangClick() {
				this.$message('暂时不支持！');
				return;
				
				let arr = []
				for (let item of this.deleteList) {
					console.log(item.id, 777777);
					arr.push(item.id)
				}
				let params = {
					id: arr
				}
				noticeListDelete(params).then((res) => {
					console.log(res, '删除');
					this.$message('批量删除成功！');
					this.noticeListSeacher()
				}).catch((err) => {
					console.log(err);
				})
			},

			xiugai(item) {
				this.objLookTeacher.detailsObj = item
				this.AddStrategyView = true
			},

			//删除
			deleteClick(item) {
				if (this.objLookTeacher.schoolId != '' && this.objLookTeacher.schoolId != null) {
					this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						deleteFaceStrategy(item.id).then((res) => {
							console.log(res, '删除');
							this.$message({
								type: 'success',
								message: '删除成功！'
							});
							this.noticeListSeacher()
						}).catch((err) => {
							console.log(err);
						})
					}).catch(() => {
						// 取消操作
					});
				} else {
					this.$message({
						message: '暂无权限进行该操作！',
						type: 'warning'
					});
				}
			},

			sendStrategy() {
				if(this.selectList.length == 0){
					this.$message({
						message: "请勾选操作对象",
						type: 'error'
					});
					return;
				}
				
				if (this.objLookTeacher.schoolId != '' && this.objLookTeacher.schoolId != null) {
					this.$confirm('下发选中策略, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let arr = []
						for (let item of this.selectList) {
							arr.push(item.strategyId)
						}
						
						issuedStrategy(this.userId,arr).then((res) => {
							if (res.data.code == 200) {
								this.$message({
									type: 'success',
									message: '操作成功！'
								});
							} else {
								this.$message({
									message: res.data.message,
									type: 'error'
								});
							}
						}).catch((err) => {
							console.log(err);
						})
					}).catch(() => {
						// 取消操作
					});
				} else {
					this.$message({
						message: '暂无权限进行该操作！',
						type: 'warning'
					});
				}
			},

			handleSelectionChange(val) {
				this.selectList = val
				console.log(this.deleteList, '多选7777');
			},

			//列表
			noticeListSeacher() {
				let params = {
					loginId: this.userId,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
				}

				strategyPage(params).then((res) => {
					this.tableData = res.data.data.records
					this.total = res.data.data.total
				}).catch((err) => {
					console.log(err, 2);
				})
			},

			AddclickXinxi() {
				if (this.objLookTeacher.schoolId != '' && this.objLookTeacher.schoolId != null) {
					this.AddStrategyView = true;
					this.objLookTeacher.detailsObj = {};
					this.titleValue = "新增策略";
				} else {
					this.$message({
						message: '该账号没有权限，请登录学校账号！',
						type: 'warning'
					});
				}
			},

			backClick() {
				this.objLookTeacher.detailsObj = {};
				this.AddStrategyView = false;
				this.noticeListSeacher();
			},

			handleSizeChange(val) {
				console.log(`${val} items pr page`)
			},

			handleCurrentChange(val) {
				this.pageInfo.page = val
				this.callRecordsClick()
			}
		}
	};
</script>
<style lang='scss' scoped>
	.fuzzy-matching-box {
		height: 96%;

		.header-Top-Box {
			height: auto;
			background-color: #fff;
			border-radius: 5px;
			padding-top: 30px;
			padding-bottom: 30px;

			.anquan-text {
				// line-height:-20% !important;
				font-size: 18px;
				font-weight: 700;
				// margin-left: 20px;
				width: 50%;

			}

			:deep() {

				.el-select--small .el-select__wrapper {
					height: 35px;
					border-radius: 5px;
				}


				.el-input--small .el-input__wrapper {
					margin-right: 15px;
					border-radius: 5px;
				}

				.el-select--small {
					width: 100%
				}

				.el-form-item--small .el-form-item__label {
					width: 110px;
					text-align: right;
					height: 35px;
					line-height: 35px;
					font-weight: 700;
					font-size: 16px;
				}

				.el-form-item {
					width: 109%;
					margin-left: 15px;
					margin-top: 20px;

				}

				.el-input {
					width: 100%;
					height: 35px;
				}

				.query-button {
					padding: 18px 24px;
					margin-top: 18px;
					border-radius: 5px;
					font-size: 14px;
					font-weight: bold;
				}


				.red_bottom {
					background-color: red;
					color: white;
				}

				.green_bottom {
					background-color: #1BC896;
					color: white;
				}

				.blue_bottom {
					background-color: blue;
					color: white;
				}
			}

		}

		.center-table-box {
			height: 86%;
			margin-top: 20px;
			background-color: #fff;
			border-radius: 10px;
			padding: 20px;

			.table-Style {
				// border-radius: 1 px;
			}

			.shanchuBtn {
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			.send_strategy {
				font-size: 15px;
				font-weight: 700;
				color: #1BC896;
			}

			.xiugaiBtn {
				font-size: 15px;
				font-weight: 700;
			}

			.scope_grenn {
				background-color: #e0ffe9;
				border: 1px solid #efefef;
				color: #1BC896;
				border-radius: 5px;
				font-size: 14px;
				padding: 13px;
			}

			.scope_red {
				background-color: #ffb6b7;
				border: 1px solid #efefef;
				font-size: 14px;
				padding: 13px;
				color: red;
				border-radius: 5px;
			}

			.scope_blue {
				background-color: #aedcff;
				border: 1px solid #efefef;
				color: #00aaff;
				border-radius: 5px;
				font-size: 14px;
				padding: 13px;
			}

			:deep() {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					font-weight: 700;
					text-align: center;
				}

				.el-table .cell {
					text-align: center;

				}

				.el-table__header {
					line-height: 30px !important;
					height: 30px;
					font-size: 15px;
					font-weight: 700;
					border-radius: 15px;

				}

				.el-table--enable-row-transition .el-table__body td.el-table__cell {
					// border: none;
					height: 40px;
					font-size: 14px;
				}
			}

			.block-fenye {
				margin-top: 20px;
				margin-left: 40%;
			}
		}
	}
</style>